import script from "./Schedule.vue?vue&type=script&setup=true&lang=js"
export * from "./Schedule.vue?vue&type=script&setup=true&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=b25cd618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b25cd618"]])

export default __exports__